import * as T_T from 'cryface';
import { cloneDeep } from 'lodash';

export function hybridShareCommunityGenderOptions(vs: any) {
    const sum = T_T.sum(vs.Data.map((v: any) => (Number(v['Value']))));
    const data: any = vs.Data.map((v: any) => ({
        name: `${v['Key']}: (${Math.round(Number(v['Value']) / sum * 10000) / 100}%)`,
        value: Number(v['Value']),
        title: `${v['Key']}`,
    }));
    const preLegend = data.map((v: any) => (`${v.name}`));
    const legend = preLegend.filter((v: any) => {
        return preLegend.indexOf(v) < 8;
    });
    const fraction = Number(data[0].value) / sum;
    let storyTitle = 'Male/Female: Evenly';
    const storyValue = `${Math.round(data[0].value / data[1].value * 100) / 100}`;
    storyTitle = fraction > 0.66 ? `Male/Female: ${data[0].title} Main` : storyTitle;
    // storyValue = fraction > 0.66 ? data[0].value : storyValue;
    storyTitle = (1 - fraction) > 0.66 ? `Male/Female: ${data[1].title} Main` : storyTitle;
    // storyValue = (1 - fraction) > 0.66 ? data[1].value : storyValue;
    const options = {
        rifoStory: {
            title: storyTitle,
            value: storyValue,
        },
        legend: {
            // orient: 'vertical',
            x: 'left',
            data: legend,
        },
        series: [
            {
                name: 'Gender',
                type: 'pie',
                data: data,
                radius: ['60%', '70%'],
                center: ['50%', '40%'],
                label: {
                    normal: {
                        formatter: '{d}%',
                        // formatter: '{b}\r\n({d}%)',
                        position: 'inside',
                        show: false,
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                itemStyle: {
                    emphasis: {
                        // shadowBlur: 10,
                        // shadowOffsetX: 0,
                        // shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };
    return options;
}
